import { cn } from '../../../common/functions/cn';

/** The input group's `has-*` focus styles outrank plain classes, hence the `!`. */
export const comboboxInlineInputStyles = cn(
  'rounded-none border-x-0 border-t-0 bg-transparent',
  'border-border! ring-0!'
);
